var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"the-modal"},[_c('div',{staticClass:"tm__close",on:{"click":function($event){return _vm.$emit('input', false)}}},[_vm._v(" X ")]),_c('div',{staticClass:"the-modal-content"},[_c('b-container',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }